import { Reducer, Action } from 'redux'
import { ICompanyInfo, ICompanyInfoState } from 'types/carrier'
import {
  COMPANY_INFO_ACTION_TYPE,
  CARRIER_INFO_DIALOG_ACTION_TYPES,
  EDIT_CARRIER_INFO_ACTION_TYPE,
} from 'apps/carrier/utils/actions/carrierInfo'

const { CLOSE_CARRIER_INFO_DIALOG, OPEN_CARRIER_INFO_DIALOG } = CARRIER_INFO_DIALOG_ACTION_TYPES
const {
  EDIT_CARRIER_INFO_FAILURE,
  EDIT_CARRIER_INFO_REQUEST,
  EDIT_CARRIER_INFO_SUCCESS,
} = EDIT_CARRIER_INFO_ACTION_TYPE
const {
  COMPANY_INFO_FAILURE,
  COMPANY_INFO_REQUEST,
  COMPANY_INFO_SUCCESS,
} = COMPANY_INFO_ACTION_TYPE

const defaultState: ICompanyInfoState = {
  info: {
    legalName: '',
    mcNumber: '',
    dbaName: '',
    dotNumber: '',
    ein: '',
    isCarbCompliant: false,
    eldCompliant: false,
    isDisadvantagedBusinessEntity: false,
  },
  loading: true,
  updating: false,
  error: undefined,
  dialogError: undefined,
  showDialog: false,
}

interface ISuccessAction extends Action<string> {
  payload: ICompanyInfo
}
interface IFailureAction extends Action<string> {
  error: string
}

type CompanyInfoReducerAction = ISuccessAction | IFailureAction

const companyInfoReducer: Reducer<ICompanyInfoState, CompanyInfoReducerAction> = (
  state = defaultState,
  action
) => {
  switch (action.type) {
    case COMPANY_INFO_REQUEST:
      return {
        ...state,
        loading: true,
        error: undefined,
      }
    case COMPANY_INFO_SUCCESS: {
      const { payload } = action as ISuccessAction
      return {
        ...state,
        info: payload,
        loading: false,
      }
    }
    case COMPANY_INFO_FAILURE: {
      const { error } = action as IFailureAction
      return {
        ...state,
        loading: false,
        error,
      }
    }
    case EDIT_CARRIER_INFO_REQUEST:
      return {
        ...state,
        dialogError: undefined,
        updating: true,
      }
    case EDIT_CARRIER_INFO_SUCCESS: {
      const { payload } = action as ISuccessAction
      return {
        ...state,
        info: payload,
        updating: false,
        showDialog: false,
      }
    }
    case EDIT_CARRIER_INFO_FAILURE: {
      const { error } = action as IFailureAction
      return {
        ...state,
        updating: false,
        dialogError: error,
      }
    }
    case OPEN_CARRIER_INFO_DIALOG: {
      return {
        ...state,
        showDialog: true,
      }
    }
    case CLOSE_CARRIER_INFO_DIALOG: {
      return {
        ...state,
        showDialog: false,
        dialogError: undefined,
      }
    }
    default:
      return state
  }
}

export default companyInfoReducer
